export default {
	TEACHER: 'teacher_settings',
	STUDENT: 'student_settings',
	NONE: 'no_settings',
}
